import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';

import { ChurnFlowReasonInfoboxService } from '@core/churn-flow-logic';
import { ChurnFlowSolutionCardI, ChurnReason } from '@core/churn-flow-types';
import {
  ChurnFlowReasonTemplateComponent,
  ChurnFlowSolutionCardComponent,
  ChurnFlowStepTemplateComponent,
} from '@core/churn-flow-ui';
import { TranslatePipe } from '@core/i18n-legacy';
import { ButtonComponent, IconComponent } from '@core/user-interface-legacy';

import { ChurnFlowInsightsComponent } from '../../components/churn-flow-insights/churn-flow-insights.component';
import { ChurnFlowReasonBaseComponent } from '../../components/churn-flow-reason-base.component';

@Component({
  selector: 'tlc-churn-other-reason-page',
  templateUrl: './churn-other-reason-page.component.html',
  styleUrls: ['./churn-other-reason-page.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    ChurnFlowInsightsComponent,
    ChurnFlowReasonTemplateComponent,
    ChurnFlowSolutionCardComponent,
    ChurnFlowStepTemplateComponent,
    IconComponent,
    TranslatePipe,
  ],
})
export class ChurnOtherReasonPageComponent extends ChurnFlowReasonBaseComponent {
  protected readonly reason = ChurnReason.Other;
  public readonly infoboxMessage: Signal<string | undefined> = inject(
    ChurnFlowReasonInfoboxService,
  ).getReasonInfoboxMessage(ChurnReason.Other);

  public readonly contactSpecialist: ChurnFlowSolutionCardI = {
    iconVariant: 'dialog',
    title: this.t('tlc.churn_flow.steps.other.solutions.help_us_understand.title'),
    incentives: [
      this.t('tlc.churn_flow.steps.other.solutions.help_us_understand.incentive_1'),
      this.t('tlc.churn_flow.steps.other.solutions.help_us_understand.incentive_2'),
    ],
    ctaText: this.t('tlc.churn_flow.steps.other.solutions.help_us_understand.cta'),
  };

  public contactSpecialistAction(): void {
    this.openIntercom(
      this.t('tlc.churn_flow.steps.other.solutions.help_us_understand.intercom_message'),
    );
  }
}
